import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { IntlShape, injectIntl } from 'react-intl';
import { Grid, Typography, Card } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import feeNoteIcon from 'images/fee-note-icon.svg';
import warning from 'images/warning.svg';
import messages from 'containers/TransactionManagerTimeLine/ExpertReport/messages';
import { makeSelectMissionsExpertiseTransaction } from 'containers/TransactionManagerTimeLine/selector';
import RecapReport from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/Recap';
import { SpacingBottom } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/styles';
import CoreButton from 'components/Buttons/CoreButton';
import {
  extractTimeLineId,
  isAssignedArea,
  shouldDisplayWarningIpp,
} from 'containers/TransactionManagerTimeLine/utils';
import { translate } from 'containers/services/translate';
import { COLORS } from 'constants/design';
import {
  EXPERTISE,
  TRANSACTION_STEPS,
} from 'containers/TransactionManagerTimeLine/constants';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { TransactionType } from 'typings/globalTypes';

export interface ExpertReportProps {
  intl: IntlShape;
  requestMakeDecisionMissionExpertise: Function;
  claimId: number;
  claimNumber: string;
  riskKey: string;
  setOpenFeeNoteDialog: Function;
  requestGetMissionVictimExpertise: Function;
  transactionId: number;
  requestGetFeeNotesTransaction: Function;
  onPressFeeNote: Function;
  isConsultation?: boolean;
  transactionInfo: TransactionType;
  listings: any;
  allExpertReport?: any;
  responsibilityShare?: any;
  victims?: any;
  lossDate?: any;
  requestGetDocByDocumentumId: Function;
  isIntervenant?: boolean;
}

export const FeeNoteButton = styled.div`
  min-height: 48px;
  padding-left: 15px;
  border-radius: 4px;
  padding: 2px;
  text-align: end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .title-class {
    margin-left: 15px;
  }
  .drop-down-button {
    font-size: 13px;
    justify-content: flex-start;
    font-weight: 500;
    color: #0075c9;
    margin-left: 15px;
    margin-right: 15px;
    text-transform: none;
    opacity: 1;
    letter-spacing: 0.02px;
    text-transform: uppercase;
  }
`;
export const StyledCard = {
  backgroundColor: COLORS.LIGHT_ORANGE,
  padding: '8px 16px 8px 8px',
  width: '80%',
  marginLeft: '30px',
  marginBottom: '20px',
};
export const StyledText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  fontWeight: 500,
};
const ExpertReport: React.FC<ExpertReportProps> = props => {
  useEffect(() => {
    props.requestGetMissionVictimExpertise({
      transactionId: props.transactionId,
      isIntervenant: props.isIntervenant,
    });
    props.requestGetFeeNotesTransaction({
      transactionId: props.transactionId,
    });
  }, [props.transactionId]);
  const expertiseVictim: any = useSelector(
    makeSelectMissionsExpertiseTransaction(),
  );

  const handleOpenDialogFeeNote = () => {
    props.onPressFeeNote();
  };

  const shouldDisplayDecisionButton = () => {
    const pendingTasks = get(props.transactionInfo, 'timeLine', []).find(
      (el: any) =>
        el.step === TRANSACTION_STEPS.EXPERTISE &&
        el.status != STATUS_VALIDATED,
    );

    const currentUserInboxes = isAssignedArea(
      props.transactionInfo,
      props.listings,
      EXPERTISE,
    );
    return (
      !props.isConsultation && !isEmpty(pendingTasks) && currentUserInboxes
    );
  };

  return (
    <Grid container direction={'column'} spacing={2}>
      {(!props.isConsultation ||
        !isAssignedArea(props.transactionInfo, props.listings, EXPERTISE)) && (
        <FeeNoteButton>
          <CoreButton
            className="drop-down-button"
            title={translate(messages.feeNoteTitle, props)}
            titleclass={'title-class'}
            onClick={handleOpenDialogFeeNote}
            lefticon={<img src={feeNoteIcon} alt="FeeNoteIcon" />}
          />
        </FeeNoteButton>
      )}
      {shouldDisplayWarningIpp(expertiseVictim) &&
        isAssignedArea(props.transactionInfo, props.listings, EXPERTISE) && (
          <Card style={StyledCard} elevation={0}>
            <Grid container direction="row" spacing={1}>
              <Grid item>
                <img src={warning} alt="warning" />
              </Grid>
              <Grid item>
                <Typography style={StyledText}>
                  {translate(messages.warningIppTitle, props)}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        )}
      {!isEmpty(expertiseVictim) &&
        expertiseVictim.map((element: any) => (
          <Grid item style={SpacingBottom}>
            <RecapReport
              recap={{
                ...element,
                victim: get(element, 'mission.victims[0]'),
                victimIncome: get(element, 'victimRevenue'),
                claimId: props.claimId,
              }}
              requestMakeDecisionMissionExpertise={
                props.requestMakeDecisionMissionExpertise
              }
              isLawyer={
                props.isConsultation ||
                !isAssignedArea(
                  props.transactionInfo,
                  props.listings,
                  EXPERTISE,
                ) ||
                !shouldDisplayDecisionButton()
              }
              claimNumber={props.claimNumber}
              expertises={expertiseVictim}
              riskKey={props.riskKey}
              setOpenFeeNoteDialog={handleOpenDialogFeeNote}
              isTransaction={true}
              transactionId={props.transactionId}
              timelineId={extractTimeLineId(
                props.transactionInfo,
                TRANSACTION_STEPS.EXPERTISE,
              )}
              responsibilityShare={props.responsibilityShare}
              victims={props.victims}
              lossDate={props.lossDate}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          </Grid>
        ))}
    </Grid>
  );
};
export default injectIntl(ExpertReport);
